import { useForm as createUseForm } from "@ant-design-vue/use";
import { Button, notification } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal, removeModal } from "../../app.logic";
import i18n from "../../i18n";
import store from "../../store";
import { modalStyleForm } from "../../utils/constant";
import { conditionFormChecker, initUseForm, putField } from "../../utils/form";
import { required, validateError } from "../../utils/validate";
import { createFieldInputNumber, createFieldInput } from "../input/template-builder/template-builder.logic";

const VerifyOtp = defineAsyncComponent(() => import("./VerifyOtp"));

export const callOtpGenertate = ({ form }) => store.dispatch(`resource/v1/security/otp/generate`, { data: form });

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true, isWaitApprove: data.isWaitApprove === true ? true : null }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        code: null,
        otp: null,
        mobile: null,
        mobileShow: null,
        expiredDatetime: null,
        isConfirm: null,
    };
};

export const createRules = () => {
    return {
        otp: [required],
    };
};

export const createField = ({ props, data }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;

    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "mobileShow",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.otp.tel"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.mobileShow,
                            "onUpdate:value": (value) => (modelRef.mobileShow = value),
                            disabled: true,
                            comma: false,
                            maxDecimal: 10,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "otp",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.otp.otp"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.otp,
                            "onUpdate:value": (value) => (modelRef.otp = value),
                            disabled: viewOnly,
                            comma: false,
                            maxDecimal: 6,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ],
    });
};

export const loadForm = ({ data }) => {
    let promise = callOtpGenertate({ form: data.useForm.modelRef }).catch((error) => {
        if (error.response?.data.message === "error.v1OtpService.estimated") {
            data.isWaitApprove = true;
        }
        validateError({ error });
        throw error;
    });

    data.color="color:null"
    const mobileShow = data.useForm?.modelRef?.mobile;
    data.useForm.modelRef.mobileShow = mobileShow.replace(mobileShow.substr(6), "xxxx");
    return promise
        .then((otp) => initUseForm({ data, page: { data: [otp] } }))
        .then(() => {
            data.isGenOtp = false;
            data.timeGen = 180;
            const interval = setInterval(() => {
                data.timeGen--;
                if (data.timeGen < 1) {
                    data.isGenOtp = true
                    clearInterval(interval);
                }
                if (data.timeGen < 79) {
                    data.color = "color:red"
                }
            }, 1000);
        });
};

export const initForm = ({ props, data, refs, emit }) => {
    data.form = data.form ? data.form : createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, emit });
    loadForm({ props, data, refs });
};

export const resend = ({ props, data, refs }) => {
    loadForm({ props, data, refs }).then(() => notification["success"]({ message: i18n.global.t("views.otp.resendSuccess") }));
};

export const openModal = ({ props, onOkCallback }) => {
    const refs = reactive({ otp: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            title: i18n.global.t("views.otp.title"),
            width: "520px",
            maskClosable: false,
            closable: false,
            footer: () => modelFooterButton({ refs: refs, options, onOkCallback }),
            // okText: i18n.global.t("views.otp.title"),
            // onOk: () => {
            //     refs.otp.callOnClickModalOk().then((otp) => {
            //         onOkCallback?.({ otp, options });
            //     });
            // },
            // onCancel: () => {
            //     if (refs.otp?.data.isGenOtp === true) {
            //         options.bind.visible = false;
            //     }
            // },
        }),
        render: () => (
            <VerifyOtp
                ref={(e) => {
                    if (e) refs.otp = e;
                }}
                {...props}
            ></VerifyOtp>
        ),
    });
};

export const modelFooterButton = ({ refs, options, onOkCallback }) => {
    const onOk = () => {
        refs.otp.callOnClickModalOk().then((otp) => {
            onOkCallback?.({ otp, options });
        });
    }
    const onCancel = () => {
        if (refs.otp?.data.isGenOtp === true) {
            //options.bind.visible = false;
            removeModal({ options })
        }
    }
    return (<div><Button disabled={refs.otp?.data?.isGenOtp === false } onClick={onCancel}>Cancel</Button><Button type="primary" onClick={onOk}>OK</Button></div>)
};
